/**
 * Licensed Materials - Property of IBM
 *
 * 'Restricted Materials of IBM'
 *
 * (C) Copyright IBM Corp. 2018,2022
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { Component } from 'react';
import PropTypes from 'util/PropTypes';
import { observer } from 'mobx-react';
import VisualizationPreviewListSlider from 'lib/@waca/vis-recommender/src/js/preview/VisualizationPreviewListSlider';
import PredictSpecConverter from 'util/PredictSpecConverter';
import StringResources from 'nls/StringResources';

import './cometFooter.scss';

/**
* The class renders explore card foodter view. Centerina type of explore card has dedicated
*	Footer view, such as explore card that contains Comet chart, in that case, the footer view
* renders related visualization when clicking one node on the comet chart
**/
@observer
class CometFooterView extends Component {
	/***
	*@constructor
	**/
	constructor(props) {
		super(props);
		this.predictSpecConverter = new PredictSpecConverter(
			{
				dashboardApi: props.layoutOwner.layoutController.boardModel.dashboardApi
			});
		this.prevKey = null;
	}
	onDotClick(options){
		this.props.model.setVisIndexToShow(options.indexClicked);
	}

	render() {
		const selections = this.props.model.getSelections();
		const localFilters = this.props.model.getLocalFilters();
		this._resetRecommendationsIfNeeded(selections, localFilters);
		return(
			<div className='vis-preview-list-slider-wrapper' >
				<div className='vis-preview-list-slider-wrapper-child'>
					{this._renderVisPreviewList(selections)}
				</div>
			</div>
		);
	}

	_renderVisPreviewList(selections){
		if(!selections.length){
			//Default Text
			return (
				<div className='defaultTextPlaceholder'>
					<div className='defaultText'>
						<div className='title'>{StringResources.get('footerView_title')}</div>
						<div className='description'>{StringResources.get('footerView_description')}</div>
					</div>
				</div>
			);
		}
		//PreviewList
		return(<VisualizationPreviewListSlider items={this.props.model.getRecommendations()}
			predictData = {this.props.model.getFooterRenderData()}
			isPredictPreview = {true}
			model = {this.props.model.getSelections()}
			horizontal= {true}
			dashboardApi={this.props.dashboardApi}
			onAddItem={this._onAddItem.bind(this)}
			onClickItem={this._onClickItem.bind(this)}
			visStartingIndex={this.props.model.getVisIndexToShow()}
			onDotClick={this.onDotClick.bind(this)}/>
		);
	}

	_onAddItem(recommendation){
		this.predictSpecConverter.onAddItem(recommendation);
		this.props.onAddItem(recommendation);
	}

	_onClickItem(recommendation){
		this.predictSpecConverter.onAddItem(recommendation);
		this.props.onClickItem(recommendation);
	}

	componentWillUnmount(){
		this.predictSpecConverter.onComponentUnmount();
	}


	generateRecommandations(selections){
		return new Promise(function(resolve){
			const vis = this.predictSpecConverter.collectPredictVisRecommendations(selections);
			this.props.model.getSavedPrompts()
				.then(savedPrompts => {
					this.predictSpecConverter.transformPredictRecommendations(vis).then((specs) => {
						const recommendations = [];
						specs.forEach( (spec) => {
							/* set local filters to spec.
							local filters can be empty if they get removed in the previous action */
							spec.localFilters = this.prevLocalFilters;
							if (savedPrompts) {
								spec.savedPrompts = savedPrompts;
							}

							recommendations.push({
								widgets: [
									{
										spec: spec
									}
								],
								name: ''
							});
						});
						resolve(recommendations);
					});

				});
		}.bind(this));
	}

	_isSelectionsChange(selections){
		if (selections && selections.length > 0){
			return selections[0].key !== this.prevKey;
		} else{
			return true;
		}
	}

	/* check local filters JSON equality */
	_hasLocalFiltersChanged(localFilters){
		return JSON.stringify(this.prevLocalFilters) !== JSON.stringify(localFilters);
	}
	/**
	 * resets the recommendations in the comet view model if selections or local filters have changed
	 * extracting this function out from render for proper testing
	 * @param {Array} selections
	 * @param {Array} localFilters
	 * @returns Promise
	 */
	_resetRecommendationsIfNeeded(selections, localFilters){
		if(this._isSelectionsChange(selections) || this._hasLocalFiltersChanged(localFilters)){
			this.prevKey = selections.length > 0 ? selections[0].key: null;
			this.prevLocalFilters = localFilters;
			this.props.model.setRecommendations([]);
			return this.generateRecommandations(selections)
				.then(recommendations => this.props.model.setRecommendations(recommendations));
		}
		return Promise.resolve([]);
	}
}

CometFooterView.propTypes = {
	model: PropTypes.object,
	dashboardApi: PropTypes.object,
	horizontal: PropTypes.bool,
	onAddItem: PropTypes.func,
	onClickItem: PropTypes.func,
	layoutOwner: PropTypes.object
};

export default CometFooterView;



// WEBPACK FOOTER //
// ./src/js/layout/explorecard/comet/CometFooterView.js